<template>
  <div id="app" :class="{'home': $route.path === '/', 'works': $route.path === '/works', 'detail': $route.params.workId }">
    <Loading v-if="loading" ref="loading"/>
    <div class="l-wrapper">
      <Header/>
      <router-view @hover="mouseHover" @hoverDestroy="mouseHoverDestroy" :loading="loading"/>
      <Footer v-if="footer" />
      <Pagetop v-if="footer" />
      <MouseCursor ref="cursor"/>
    </div>
  </div>
</template>

<script>
import Header from './components/Header'
import Footer from './components/Footer'
import Pagetop from './components/Pagetop'
import MouseCursor from './components/Cursor'
import Loading from './components/Loading'

export default {
  name: 'App',
  components: {
    Header,
    Footer,
    Pagetop,
    MouseCursor,
    Loading
  },
  data() {
    return {
      loading: true,
      footer: false,
      back: false,
      transitionName: 'forward'
    }
  },
  created() {
    window._vue_onpopstate = () => this.onPopState()
    this.$router.beforeEach((to, from, next) => {
      this.transitionName = this.back ? 'backward' : 'forward'
      this.back = false

      //console.log(this.transitionName, ':' , from.name)
      if (this.transitionName === 'forward') {
        setTimeout(() => {
          next();
        }, 850);
      } else {
        next();
      }
    })
  },
  methods: {
    loadingComplete() {
       const wait = (milliseconds) => new Promise((resolve) => setTimeout(resolve, milliseconds));
        Promise.resolve()
        .then( () => wait(1500) )
        .then( () => this.$refs.loading.$el.classList.add("is-fadein") )
        .then( () =>  wait(1000) )
        .then( () => {
          this.loading = false;
        });
    },
    mouseHover() {
      this.$refs.cursor.mouseHover();
    },
    mouseHoverDestroy() {
      this.$refs.cursor.mouseHoverDestroy();
    },
    onPopState() {
      this.back = true
    },
    onNavigate() {

    }
  },
  mounted() {
    this.loadingComplete();
  }
}
</script>

<style lang="scss">
main {
  &::before {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #f5f4f9;
    z-index: 301;
  }
  &.is-fadein {
    &::before {
      transform: translateY(-100%);
      transition: transform .6s ease-out;
      pointer-events: none;
    }
  }
}
.is-hide {
  opacity: 0;
}

</style>
